import config from '../config';
import MPUtils from '../utils/MPUtils';

const SLIDER_ON = 'slider-on.png';
const SLIDER_OFF = 'slider-off.png';

let soundManager;
let dataManager;

class Settings extends Phaser.Scene {
  init () {
    // console.log('Settings.init');
    let g = this;

    soundManager = g.scene.get('SoundManager');
    soundManager.pauseMusic();

    dataManager = g.sys.game.dataManager;

    g.scene.pause(dataManager.getSessionItem(config.BASE_SCENE));
  }
  create () {
    // console.log('Settings.create');
    let g = this;

    let bg = g.add.sprite(config.CENTER_X, config.CENTER_Y, 'overlay');
    bg.setAlpha(0);

    let group = [];
    let xPos = -(config.WIDTH / 2);
    // let xPos = config.CENTER_X;

    let box = g.add.sprite(xPos, config.CENTER_Y, 'settings-box');
    group.push(box);

    let arm = g.add.sprite(box.x, box.y - 235, 'settings-arm');
    arm.play('settings-arm-loop');
    group.push(arm);

    let bears = g.add.sprite(box.x, box.y - 235, 'settings-bears');
    bears.play('settings-bears-loop');
    group.push(bears);

    let flash = g.add.sprite(box.x, box.y, 'settings-flash');
    flash.setAlpha(0);
    group.push(flash);

    arm.on('animationupdate', (e) => {
      if (arm.frame.name === 'panda-arm_97.png') {
        flash.setAlpha(1);
        g.tweens.add({
          targets: flash,
          alpha: 0,
          duration: 250
        });
      }
    });

    let headerStringKey = dataManager.getSessionItem(config.BASE_SCENE) === 'Play' ? 'paused' : 'settings';
    let headerText = g.add.text(xPos, config.CENTER_Y + 10, g.sys.game.localisationManager.GetString(headerStringKey), { fontFamily: '"FredBurger Black"', fontSize: 64 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 3)
    MPUtils.ClampTextToDimensions(headerText, 375, 200);
    group.push(headerText);

    let playBtn = g.add.sprite(xPos, config.CENTER_Y + 210, 'common');
    playBtn.setFrame('play-icon-b.png');
    playBtn.setInteractive();
    playBtn.once('pointerdown', () => {
      g.tweens.add({
        targets: bg,
        alpha: 0,
        duration: 250
      });
      g.tweens.add({
        targets: group,
        x: '+=' + config.WIDTH,
        duration: 250,
        ease: 'Quad.easeOut',
        onComplete: () => {
          g.scene.stop('Settings');
          g.scene.resume(dataManager.getSessionItem(config.BASE_SCENE));
        }
      });
    });
    group.push(playBtn);

    let musicOn = dataManager.getItem(config.MUSIC_ON);
    let soundsOn = dataManager.getItem(config.SOUNDS_ON);

    let mSlider = g.add.sprite(xPos - 150, playBtn.y, 'common');
    group.push(mSlider);
    mSlider.setFrame(musicOn ? SLIDER_ON : SLIDER_OFF);
    group.push(mSlider);
    // mSlider.setOrigin(0, 0.5);
    let mIcon = g.add.sprite(mSlider.x, mSlider.y - 60, 'common');
    mIcon.setFrame('music-icon.png');
    group.push(mIcon);

    let sSlider = g.add.sprite(xPos + 158, playBtn.y, 'common');
    group.push(sSlider);
    sSlider.setFrame(soundsOn ? SLIDER_ON : SLIDER_OFF);
    group.push(sSlider);
    let sIcon = g.add.sprite(sSlider.x, playBtn.y - 60, 'common');
    sIcon.setFrame('sfx-icon.png');
    group.push(sIcon);

    mSlider.setInteractive();
    mSlider.on('pointerdown', () => {
      // console.log('mSlider clicked', mSlider.frame.name);
      musicOn = !musicOn;
      dataManager.setItem(config.MUSIC_ON, musicOn);
      mSlider.setFrame(mSlider.frame.name === SLIDER_ON ? SLIDER_OFF : SLIDER_ON);
    });
    sSlider.setInteractive();
    sSlider.on('pointerdown', () => {
      // console.log('sSlider clicked');
      soundsOn = !soundsOn;
      dataManager.setItem(config.SOUNDS_ON, soundsOn);
      sSlider.setFrame(sSlider.frame.name === SLIDER_ON ? SLIDER_OFF : SLIDER_ON);
    });

    let versionText = g.add.text(xPos, config.CENTER_Y + 360, 'v ' + __VERSION__, { fontFamily: '"FredBurger Black"', fontSize: 24 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 2)
    MPUtils.ClampTextToDimensions(versionText, 250, 1000);
    group.push(versionText);

    if (dataManager.getSessionItem('levelKey') !== undefined) {
      var levelKey = dataManager.getSessionItem('levelKey');
      var levelNum = levelKey.split('-')[1];
      var levelStr = g.sys.game.localisationManager.GetString('level');
      levelStr = levelStr.replace("<!VALUE>", levelNum);

      let levelText = g.add.text(xPos, config.CENTER_Y + 330, levelStr, { fontFamily: '"FredBurger Black"', fontSize: 24 +"px", color: "#FFF" }).setOrigin(0.5).setStroke('#000', 2)
      MPUtils.ClampTextToDimensions(levelText, 250, 1000);
      group.push(levelText);
    }

    g.tweens.add({
      targets: bg,
      alpha: 1,
      duration: 250
    });
    g.tweens.add({
      targets: group,
      x: '+=' + config.WIDTH,
      duration: 500,
      ease: 'Back.easeOut'
    });
  }
}

export default Settings;
